import {MutationTree} from 'vuex';
import {
  EntityTimeTransaction, EntityTimeTransactionService,
  TimeTransactionInitState
} from '@/store/time-transaction/time-transaction.types';

export const TimeTransactionMutations: MutationTree<TimeTransactionInitState> = {
  ['mutationTransfer'](state: TimeTransactionInitState, payload: EntityTimeTransaction[]) {
  },
  ['mutationTimesTransactions'](state: TimeTransactionInitState, payload: EntityTimeTransactionService[]) {
    state.timeTransactions = payload;
  },
};
